/**
 * Azhara lead pages (business scenting, custom fragrance): qualifier sheet engine.
 *
 * Page contract (markup inside #bz-root):
 *   #bz-quiz                     the sheet; steps are [data-bz-step="<id>"] in cfg.order
 *   [data-bz-field][data-bz-value]   single-choice option: sets state[field], advances.
 *                                    Outside the sheet it also opens the sheet.
 *   [data-bz-multi][data-bz-value]   multi-choice chip: toggles a value in state[multi]
 *   [data-bz-input="key"]            free text copied into state[key] when leaving a step
 *   [data-bz-next]                   advances (used by multi-choice and optional steps)
 *   [data-bz-goto="<step>"]          jumps to a non-ordered step (e.g. "home" exit)
 *   [data-bz-open]                   opens the sheet at the first unanswered step
 *   [data-bz-contact]                contact <form> with inputs name, phone, org, city
 *   plan step: [data-bz-plan-title|img|reason|price|list], a[data-bz-wa], a[data-bz-plan-buy]
 *   [data-bz-atc][data-variant]      direct add to cart
 *
 * Page config, set inline before this script runs:
 *   window.AZH_LEADPAGE = {
 *     source, wa, subject, order: [...], required: [...],
 *     build: function (state, contact) -> { title, img, imgAlt, reason, price, list, waText,
 *                                           value, category, payload, buyUrl },
 *     init: function (api) {}          // optional, e.g. URL personalisation
 *   }
 *
 * fbq('track', 'Lead') fires exactly once, when the contact step is submitted.
 */
(function () {
  'use strict';

  function init() {
    var cfg = window.AZH_LEADPAGE;
    var root = document.getElementById('bz-root');
    if (!cfg || !root || root.dataset.bzInit) return;
    root.dataset.bzInit = '1';

    var ORDER = cfg.order;
    var state = {};
    var done = false;
    var leadFired = false;
    var current = ORDER[0];
    var lastFocus = null;

    var quiz = document.getElementById('bz-quiz');
    var bar = quiz.querySelector('[data-bz-bar]');
    var backBtn = quiz.querySelector('.bz-quiz__top [data-bz-back]');
    var scroller = quiz.querySelector('.bz-quiz__scroll');
    var sticky = document.getElementById('bz-sticky');
    var steps = {};
    quiz.querySelectorAll('[data-bz-step]').forEach(function (el) { steps[el.getAttribute('data-bz-step')] = el; });

    function mark(field, value) {
      root.querySelectorAll('[data-bz-field="' + field + '"]').forEach(function (o) {
        o.classList.toggle('is-active', o.getAttribute('data-bz-value') === value);
      });
    }
    function set(field, value) { state[field] = value; done = false; mark(field, value); }

    function isOpen() { return !quiz.hidden; }

    function open(step) {
      if (!isOpen()) {
        lastFocus = document.activeElement;
        quiz.hidden = false;
        document.documentElement.classList.add('bz-locked');
        try { history.pushState({ bzQuiz: 1 }, ''); } catch (_) {}
        updateSticky();
      }
      go(step || firstOpenStep());
    }

    function close(fromPop) {
      if (!isOpen()) return;
      quiz.hidden = true;
      document.documentElement.classList.remove('bz-locked');
      if (!fromPop && history.state && history.state.bzQuiz) { try { history.back(); } catch (_) {} }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      updateSticky();
    }

    function firstOpenStep() {
      if (done) return 'plan';
      var req = cfg.required || ORDER;
      for (var i = 0; i < ORDER.length; i++) {
        var k = ORDER[i];
        if (k === 'contact') return k;
        if (req.indexOf(k) !== -1 && !state[k]) return k;
      }
      return 'contact';
    }

    function go(step) {
      current = step;
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== step; });
      var idx = ORDER.indexOf(step);
      var pct = idx === -1 ? 100 : (idx / ORDER.length) * 100 + 6;
      if (bar) bar.style.width = pct + '%';
      if (backBtn) backBtn.setAttribute('aria-disabled', (idx <= 0 || step === 'plan') && step !== 'home' ? 'true' : 'false');
      scroller.scrollTop = 0;
      var h = steps[step] && steps[step].querySelector('.bz-q__h');
      if (h) setTimeout(function () { h.focus({ preventScroll: true }); }, 50);
    }

    function collectInputs(step) {
      var el = steps[step];
      if (!el) return;
      el.querySelectorAll('[data-bz-input]').forEach(function (i) { state[i.getAttribute('data-bz-input')] = (i.value || '').trim(); });
    }

    function next() {
      collectInputs(current);
      var idx = ORDER.indexOf(current);
      go(ORDER[Math.min(idx + 1, ORDER.length - 1)]);
    }

    function back() {
      if (ORDER.indexOf(current) === -1 && current !== 'plan') { go(ORDER[0]); return; }
      var idx = ORDER.indexOf(current);
      if (idx > 0) go(ORDER[idx - 1]);
    }

    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var jump = t.closest('[data-bz-goto]');
      if (jump) { if (!isOpen()) open(); go(jump.getAttribute('data-bz-goto')); return; }
      var opt = t.closest('[data-bz-field]');
      if (opt) {
        set(opt.getAttribute('data-bz-field'), opt.getAttribute('data-bz-value'));
        if (!quiz.contains(opt)) { open(); return; }
        setTimeout(next, 160);
        return;
      }
      var chip = t.closest('[data-bz-multi]');
      if (chip) {
        var f = chip.getAttribute('data-bz-multi');
        var v = chip.getAttribute('data-bz-value');
        var list = state[f] ? state[f].split(', ') : [];
        var at = list.indexOf(v);
        if (at === -1) list.push(v); else list.splice(at, 1);
        state[f] = list.join(', ');
        chip.classList.toggle('is-active', at === -1);
        chip.setAttribute('aria-pressed', at === -1 ? 'true' : 'false');
        return;
      }
      if (t.closest('[data-bz-next]')) { next(); return; }
      var opener = t.closest('[data-bz-open]');
      if (opener) {
        if (opener.hasAttribute('data-bz-preset')) {
          var p = opener.getAttribute('data-bz-preset').split('=');
          state[p[0]] = p[1];
        }
        open();
        return;
      }
      if (t.closest('[data-bz-close]')) { close(false); return; }
      if (t.closest('[data-bz-back]')) { back(); return; }
    });

    window.addEventListener('popstate', function () { if (isOpen()) close(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(false); });

    /* Contact step: validate, store, fire the one Lead, show the plan */
    var form = quiz.querySelector('[data-bz-contact]');
    function field(name) { return form.querySelector('[name="' + name + '"]'); }
    function normPhone(v) {
      var d = (v || '').replace(/\D/g, '');
      if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
      if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
      return /^[6-9]\d{9}$/.test(d) ? d : '';
    }
    function flag(name, bad) {
      var input = field(name);
      var err = form.querySelector('[data-bz-err="' + name + '"]');
      if (input) input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (err) err.hidden = !bad;
      return bad;
    }

    /* Email notification through the native contact form, posted into a hidden iframe */
    function notifyStore(contact, text) {
      try {
        var sink = document.getElementById('bz-lead-sink');
        if (!sink) {
          sink = document.createElement('iframe');
          sink.name = sink.id = 'bz-lead-sink';
          sink.style.display = 'none';
          sink.setAttribute('aria-hidden', 'true');
          document.body.appendChild(sink);
        }
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/contact#contact_form';
        f.target = 'bz-lead-sink';
        f.style.display = 'none';
        var fields = {
          form_type: 'contact',
          utf8: '✓',
          'contact[name]': contact.name,
          'contact[email]': contact.phone + '@leads.azhara.in',
          'contact[phone]': contact.phone,
          'contact[subject]': cfg.subject,
          'contact[body]': text
        };
        Object.keys(fields).forEach(function (k) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = k; i.value = fields[k];
          f.appendChild(i);
        });
        document.body.appendChild(f);
        f.submit();
        setTimeout(function () { f.remove(); }, 1500);
      } catch (_) { /* never blocks the WhatsApp handoff */ }
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var contact = {
        name: (field('name').value || '').trim(),
        phone: normPhone(field('phone').value),
        org: field('org') ? (field('org').value || '').trim() : '',
        city: (field('city').value || '').trim()
      };
      var bad = false;
      if (flag('name', contact.name.length < 2)) bad = true;
      if (flag('phone', !contact.phone)) bad = true;
      if (flag('city', contact.city.length < 2)) bad = true;
      if (bad) { var inv = form.querySelector('[aria-invalid="true"]'); if (inv) inv.focus(); return; }

      var plan = cfg.build(state, contact) || {};
      var waUrl = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(plan.waText || '');
      var payload = plan.payload || {};
      payload.form = 'qualifier';
      payload.city = contact.city;
      payload.org = contact.org;

      if (window.AzharaLeads) {
        window.AzharaLeads.capture({
          source: cfg.source,
          name: contact.name,
          phone: contact.phone,
          message: plan.waText,
          whatsapp_text: plan.waText,
          skip_fbq: true,
          payload: payload
        });
      }
      notifyStore(contact, plan.waText + '\nSource: ' + cfg.source + ' qualifier');

      if (!leadFired && typeof window.fbq === 'function') {
        leadFired = true;
        var params = { content_name: cfg.subject, content_category: plan.category || '' };
        if (plan.value) { params.value = plan.value; params.currency = 'INR'; }
        if (plan.fbq) Object.keys(plan.fbq).forEach(function (k) { params[k] = plan.fbq[k]; });
        try { window.fbq('track', 'Lead', params); } catch (_) {}
      }

      renderPlan(plan, waUrl);
      done = true;
      go('plan');
    });

    function renderPlan(plan, waUrl) {
      var p = steps.plan;
      var q = function (s) { return p.querySelector(s); };
      if (q('[data-bz-plan-title]')) q('[data-bz-plan-title]').textContent = plan.title || '';
      var img = q('[data-bz-plan-img]');
      if (img) {
        if (plan.img) { img.src = plan.img; img.alt = plan.imgAlt || ''; img.hidden = false; }
        else img.hidden = true;
      }
      if (q('[data-bz-plan-reason]')) q('[data-bz-plan-reason]').textContent = plan.reason || '';
      if (q('[data-bz-plan-price]')) q('[data-bz-plan-price]').textContent = plan.price || '';
      var list = q('[data-bz-plan-list]');
      if (list) {
        list.innerHTML = '';
        (plan.list || []).forEach(function (txt) { var li = document.createElement('li'); li.textContent = txt; list.appendChild(li); });
      }
      if (q('[data-bz-wa]')) q('[data-bz-wa]').href = waUrl;
      var buy = q('[data-bz-plan-buy]');
      if (buy) {
        buy.hidden = !plan.buyUrl;
        if (plan.buyUrl) buy.href = plan.buyUrl;
      }
    }

    /* Direct purchase path */
    root.querySelectorAll('[data-bz-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.getAttribute('data-variant'), 10);
        if (!id || btn.disabled) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error('Cart add failed: ' + r.status); return r.json(); })
          .then(function () {
            btn.textContent = 'Added';
            var refreshed = window.refreshSideCart ? window.refreshSideCart() : Promise.resolve();
            if (window.openSideCart) window.openSideCart();
            return refreshed;
          })
          .catch(function (err) { console.error('[leadpage] add to cart error', err); btn.textContent = 'Try again'; })
          .then(function () { setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500); });
      });
    });

    /* Sticky CTA: after the inline start card scrolls away, hidden near the final band and footer */
    var seen = { start: true, final: false, footer: false };
    function updateSticky() {
      if (!sticky) return;
      var on = !seen.start && !seen.final && !seen.footer && !isOpen();
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      var b = sticky.querySelector('button');
      if (b) b.tabIndex = on ? 0 : -1;
    }
    if ('IntersectionObserver' in window) {
      var map = new Map();
      var s = document.getElementById('bz-start') || root.querySelector('.bz-hero'); if (s) map.set(s, 'start');
      var fi = document.getElementById('bz-final'); if (fi) map.set(fi, 'final');
      var foot = document.querySelector('footer'); if (foot) map.set(foot, 'footer');
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var k = map.get(en.target);
          seen[k] = en.isIntersecting || (k === 'start' && en.boundingClientRect.top > 0);
        });
        updateSticky();
      }, { threshold: 0 });
      map.forEach(function (_, el) { io2.observe(el); });
    }

    if (typeof cfg.init === 'function') {
      cfg.init({ set: set, open: open, go: go, state: state });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
